import { render } from "./AutoAnnotationCard.vue?vue&type=template&id=5d575253&scoped=true"
import script from "./AutoAnnotationCard.vue?vue&type=script&lang=js"
export * from "./AutoAnnotationCard.vue?vue&type=script&lang=js"

import "./AutoAnnotationCard.vue?vue&type=style&index=0&id=5d575253&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d575253"]])

export default __exports__